export const removeSpaces = (str: string) => {
  return str.split(" ").join("");
};
